module.exports = __webpack_public_path__ + "static/media/arrow.a37dd56f.svg";